import { Stack, Box } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import DynamicTable from "../DynamicTable/DynamicTable";
import DataItem from "@components/atoms/DataItem/DataItem";
import { getCurrency } from "@utils/utils";
import MessageBar from "@components/atoms/MessageBar/MessageBar";
import { IReceiptDetailUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import TransactionalInfo from "../../molecules/TransactionalInfo/TransactionalInfo";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import InputText from "@components/atoms/InputText/InputText";
import { useForm } from "react-hook-form";
const TopRender = ({
  type,
  clientName,
  creationTime,
  limit,
  createdBy,
  lastModifiedBy
}: {
  type: number;
  clientName: string;
  creationTime: string;
  limit: string;
  createdBy: string;
  lastModifiedBy: string;
}) => <>
    <Stack direction={"row"} justifyContent={"space-between"} marginBottom={1} flexWrap={"wrap"} width={1}>
      <DataItem label="Cliente" value={clientName} />
      <DataItem label="Fecha de creación" value={creationTime} />
      {type !== 1 ? <DataItem label="Fecha límite de pago" value={limit} /> : <DataItem label="" value="" />}
    </Stack>
    <Stack direction={"row"} justifyContent={"space-between"} marginBottom={1} flexWrap={"wrap"} width={1}>
      <DataItem label="Creado por" value={createdBy || "N/A"} />
      <DataItem label="Última modificación" value={lastModifiedBy || "N/A"} />
      <DataItem label="" value="" />
    </Stack>
  </>;
const ReceiptDetailUI = ({
  id,
  name,
  type,
  clientId,
  clientName,
  creationTime,
  limit,
  createdByEmployeeName,
  lastModifiedByEmployeeName,
  total,
  total2,
  headers,
  rows,
  rows2,
  pages,
  onChangePage,
  onChangePage2,
  isLoading,
  showError,
  closeError,
  errorMessage,
  receipt,
  setReceipt,
  showDialog,
  handleConfirmDialog,
  handleCloseDialog,
  employeeCode,
  setEmployeeCode,
  applicant,
  setApplicant
}: IReceiptDetailUI) => {
  const classes = {
    innerStack: {
      width: 1,
      "& > div:nth-of-type(1)": {
        marginTop: 0
      }
    },
    inputLabel: {
      marginBottom: 1
    }
  };
  const {
    register
  } = useForm();
  return <>
      <TitlePage title={`Recibo #${id}, ${name}`} subtitle="Accede a información detallada sobre tu recibo, desde los productos hasta el monto total y la fecha de vencimiento." />
      <Stack direction={"row"} marginTop={3} spacing={3} alignItems={"flex-start"}>
        <Stack sx={classes.innerStack}>
          {type !== 1 && <DynamicTable title="Información del recibo de caja" subtitle="Resumen de productos, cliente y su fecha de pago." headers={headers} rows={rows} pages={pages} onChangePage={onChangePage} isLoading={isLoading} topRender={<TopRender type={type} clientName={clientName} creationTime={creationTime} limit={limit} createdBy={createdByEmployeeName} lastModifiedBy={lastModifiedByEmployeeName} />} bottomRender={<MessageBar label="Total productos" value={getCurrency(total)} />} />}
          {rows2.length > 0 && <DynamicTable title="Devoluciones" subtitle="Productos que han sido devueltos" headers={headers} rows={rows2} pages={pages} onChangePage={onChangePage2} isLoading={isLoading} {...type === 1 && {
          topRender: <TopRender type={type} clientName={clientName} creationTime={creationTime} limit={limit} createdBy={createdByEmployeeName} lastModifiedBy={lastModifiedByEmployeeName} />
        }} bottomRender={<MessageBar label="Total devoluciones" value={getCurrency(total2)} />} />}
        </Stack>
        <TransactionalInfo receipt={receipt} setReceipt={setReceipt} clientId={clientId} />
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
      <ConfirmDialog open={showDialog} cancelAction={handleCloseDialog} confirmAction={handleConfirmDialog} title="Eliminar producto" subtitle="¿Estás seguro de que deseas eliminar este producto?" message="Recuerda, si eliminas el producto no podrás recuperar la información una vez que se haya eliminado." cancelLabel="No eliminar" confirmLabel="Sí, eliminar" employeeCode={employeeCode} setEmployeeCode={setEmployeeCode} requireEmployeeCode={true} withEnter={true} withEscape={true} contentRender={<Box marginTop={1}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} autoFocus={true} />
            <InputText label="Solicitante" name="applicant" placeholder="Ingresa el nombre del solicitante" register={register("applicant", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setApplicant(e.target.value),
        value: applicant || ""
      })} disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} />
    </>;
};
export default ReceiptDetailUI;